"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCommonTraits = exports.getCommonTraits = function getCommonTraits() {
    if (!global.analyticsCommonTraits) {
        return false;
    }

    return Object.assign({}, global.analyticsCommonTraits);
};

var setCommonTraits = exports.setCommonTraits = function setCommonTraits(newCommonTraits) {
    if (!global.analyticsCommonTraits && !newCommonTraits) return;

    global.analyticsCommonTraits = Object.assign({}, global.analyticsCommonTraits, newCommonTraits);
};

var clearCommonTraits = exports.clearCommonTraits = function clearCommonTraits() {
    if (!global.analyticsCommonTraits) {
        return;
    }
    global.analyticsCommonTraits = false;
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/utils/commonTraits.js
// module id = 394
// module chunks = 1